import { css } from '../../../styled-system/css';

// Drawer wrapper styles
export const drawerWrapperStyles = css({
  position: 'fixed',
  top: 0,
  height: '100vh',
  width: '720px',
  maxWidth: '100vw',
  backgroundColor: 'bg.neutral',
  boxShadow: 'lg',
  zIndex: '1000',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  borderRadius: 0,

  '@media (max-width: 768px)': {
    width: '100vw',
  },
});

// Drawer alignment styles
export const drawerAlignmentStyles = {
  left: css({
    left: 0,
    right: 'unset',
  }),
  right: css({
    right: 0,
    left: 'unset',
  }),
};

export const drawerBodyStyles = css.raw({
  flex: 1,
  overflow: 'auto',
  paddingTop: 'default',
  paddingInline: 'default',
});
